import { LogOut } from "lucide-react";
import { BrandMark } from "@/components/brand/BrandMark";
import { useAuth } from "@/lib/auth/AuthContext";
import { NavList } from "./NavList";

export function Sidebar() {
  const { state, logout } = useAuth();
  const email = state.status === "authenticated" ? state.user.email : "";

  return (
    <aside className="hidden w-64 shrink-0 flex-col bg-brand-900 md:flex">
      <div className="flex h-16 items-center gap-2.5 px-5">
        <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-brand-700">
          <BrandMark className="h-6 w-6 text-white" />
        </div>
        <div className="min-w-0">
          <p className="truncate text-sm font-semibold text-white">Shalom App Control</p>
          <p className="truncate text-xs text-brand-300">Panel de administracion</p>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto py-3">
        <NavList />
      </div>

      <div className="border-t border-white/10 px-3 py-3">
        <div className="mb-2 truncate px-3 text-xs text-brand-300" title={email}>
          {email}
        </div>
        <button
          type="button"
          onClick={() => void logout()}
          className="flex min-h-11 w-full items-center gap-3 rounded-lg px-3 py-3 text-sm font-medium text-white/85 transition-colors hover:bg-brand-800/60 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/80 focus-visible:ring-offset-2 focus-visible:ring-offset-brand-900"
        >
          <LogOut className="h-4.5 w-4.5" style={{ height: "1.125rem", width: "1.125rem" }} aria-hidden="true" />
          Cerrar sesion
        </button>
      </div>
    </aside>
  );
}
